<script lang="ts">
    import Fa from 'svelte-fa'
    import { faLock } from '@fortawesome/free-solid-svg-icons'

    export let label: string
    export let required = false
    export let readOnly = false
</script>

<div class="field-heading">
    <span class="field-label">{label}</span>
    {#if required}
        <span class="required-mark" title="Preenchimento obrigatório">*</span>
    {/if}
    {#if readOnly}
        <span class="readonly-tag" title="Somente leitura para quem recebe o link">
            <Fa icon={faLock} size="xs" />
            <span>Somente leitura</span>
        </span>
    {/if}
</div>

<style>
    .field-heading {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 0.95rem;
        font-weight: 500;
        color: #212529;
        margin-bottom: 8px;
    }
    .required-mark {
        color: #e03131;
        font-weight: 700;
    }
    .readonly-tag {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        margin-left: auto;
        font-size: 0.68rem;
        font-weight: 500;
        color: #868e96;
        background: #f1f3f5;
        border-radius: 999px;
        padding: 2px 9px;
    }
</style>
